import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { Grid, Typography } from "@mui/material";
import style from "./MisReports.module.css";
import CustomSelect from "../../CommonComponents/Select/CustomSelect";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import CommonButton from "../../CommonComponents/CommonButton";
import {
  downloadReport,
  reportsDropdown,
} from "../../Services/Mis&Reports.service";
import useToaster from "../../customHook/useToaster";
import { useNavigate } from "react-router";
import { secureData } from "../../Encryption/encryption";
import { jwtDecode } from 'jwt-decode';
import { useSelector } from "react-redux";

const boxStyle = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  width: "100%",
  ml: { sx: "0", sm: "2.4rem", md: "2.4rem" },
  mt: { sx: "0", sm: "2.4rem", md: "2.4rem" },
};
const boxStyleTab = {
  width: "auto",
  marginLeft: "24px",
  marginTop: "11px",
};

const downloadReportTypography = {
  fontWeight: 600,
  fontSize: "2rem",
  color: "#3A3A3A",
};

const WholeBoxStyle = {
  width: "95%",
  border: "1px solid #898F98",
  borderRadius: "4px",
  padding: "8px 19px",
};

const downloadButtonStyle = {
  marginTop: "10px",
  width: "10rem",
  height: "3.6rem",
};

const DatePickerStyle = {
  marginTop: "6px",
  overflow: "hidden",
  transition: "none !important",
  borderRadius: "4px",
  ".MuiInputBase-input": {
    fontSize: "1.2rem",
    padding: "1.2rem 0.3rem",
    transition: "none !important",
  },
  "& .MuiInputBase-root": {
    height: "auto",
    paddingRight: 0,
    border: "1px solid #898F98",
  },
  "& label": {
    color: "#3D4756",
    fontSize: "1.2rem",
    fontWeight: 500,
    transform: "translate(14px, 13.5px) scale(1)",
    "&.Mui-focused": {
      display: "none",
    },
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "none",
    },
    "&:hover fieldset": {},
    "&.Mui-focused fieldset ": {},
    border: "1px solid #E8E8E8",
    "& .MuiButtonBase-root": {
      padding: 0,
      marginRight: "0.5rem",
    },
  },
};

const MisReports = () => {
  const [reportCategoryState, setReportCategoryState] = useState("");
  const [subReportCategoryState, setSubReportCategoryState] = useState("");
  const [quarterState, setQuarterState] = useState("");
  const [fromDateHandlerState, setFromDateHandlerState] = useState("");
  const [toDateHandlerState, setToDateHandlerState] = useState("");
  const [openSubSelect, setOpenSubSelect] = useState(false);
  const [reportsList, setReportsList] = useState([]);
  const { showToast } = useToaster();
  const navigate = useNavigate();

  const loginToken = useSelector(
    (state) => state?.loginSlice?.userData?.token
  );
  const excludeEmployeesList = [60, 61, 218];

  let isFMR =
    reportsList[reportCategoryState]
      ?.find((item) => item?.sub_category_name === subReportCategoryState)
      ?.sub_category_name?.toLowerCase() == "fmr";

  const isDailyRegCases =
    reportsList[reportCategoryState]
      ?.find((item) => item?.sub_category_name === subReportCategoryState)
      ?.sub_category_name?.toLowerCase() === "daily registered cases";

  const handleQuarterChange = (e) => {
    setQuarterState(e?.target?.value);
  };

  const handleChangeReportCategory = (e) => {
    setReportCategoryState(e?.target?.value);
    setOpenSubSelect(true);
  };
  const handleChangeSubReportCategory = (e) => {
    setSubReportCategoryState(e?.target?.value);
    setOpenSubSelect(false);
    setQuarterState("");
    setFromDateHandlerState("");
    setToDateHandlerState("");
  };

  const fromDateHandlerFun = (value) => {
    if (
      value &&
      value.month() !== undefined &&
      value.date() !== undefined &&
      value.year() !== undefined
    ) {
      setFromDateHandlerState(
        dayjs(value).add(1, "day")?.toISOString()?.split("T")[0]
      );
    }
  };
  const toDateHandlerFun = (value) => {
    if (isFMR) setToDateHandlerState(value?.year());
    if (
      !isFMR &&
      value &&
      value.month() !== undefined &&
      value.date() !== undefined &&
      value.year() !== undefined
    ) {
      setToDateHandlerState(
        dayjs(value).add(1, "day")?.toISOString()?.split("T")[0]
      );
    }
  };

  let fromDatePickerStyle;
  if (fromDateHandlerState) {
    fromDatePickerStyle = {
      ...DatePickerStyle,
      "& label": {
        display: "none",
      },
    };
  } else {
    fromDatePickerStyle = DatePickerStyle;
  }

  let toDatePickerStyle;
  if (toDateHandlerState) {
    toDatePickerStyle = {
      ...DatePickerStyle,
      "& label": {
        display: "none",
      },
    };
  } else {
    toDatePickerStyle = DatePickerStyle;
  }

  let popperStyles = {
    "& .MuiButtonBase-root.MuiIconButton-root": {
      fontSize: "1.8rem",
    },
    "& .MuiPickersYear-yearButton, & .MuiPickersCalendarHeader-label, & .MuiTypography-root, & .MuiPickersDay-root":
      {
        fontSize: "1.2rem",
      },
  };
  let newSubCategory = subReportCategoryState.split(" ").join("-");
  const handleReportsDownload = async (e) => {
    console.log(fromDateHandlerState, toDateHandlerState, "kakks");
    try {
      e.preventDefault();
      if (isFMR && toDateHandlerState <= 1902)
        return showToast("Invalid Year", "error", true);
      if (!isDailyRegCases) {
        if (
          (!fromDateHandlerState && !isFMR) ||
          (!toDateHandlerState && !isFMR)
        ) {
          return showToast("Please select valid inputs", "error", true);
        }
      }
      const url = isFMR
        ? `${process.env.REACT_APP_FMRREPORT_URL}?format=pdf&quarter=${quarterState}&year=${toDateHandlerState}`
        : isDailyRegCases
        ? `${
            process.env.REACT_APP_REPORT_BASE_URL
          }/download?report_category=${reportCategoryState}&report_sub_category=${newSubCategory?.toLowerCase()}`
        : `${
            process.env.REACT_APP_REPORT_BASE_URL
          }/download?report_category=${reportCategoryState}&report_sub_category=${newSubCategory
            ?.split(" ")
            ?.join("-")
            ?.toLowerCase()}&start_date=${fromDateHandlerState}&end_date=${toDateHandlerState}`;
      downloadReport(url)
        ?.then((response) => {
          if (response) {
            //Create file link in browser's memory
            const href = URL?.createObjectURL(response);
            //create anchor tag with href to file & click
            const link = document.createElement("a");
            link.href = isFMR ? url : href;
            document.body.appendChild(link);
            link.click();
            //clean up anchor tag & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          }
        })
        ?.catch(async (err) => {
          const errorMessage = JSON.parse(await err?.response?.data?.text());
          showToast(errorMessage?.message, "error", true);
        });
      // const link = document.createElement("a");
      // link.href = isFMR
      //   ? `${process.env.REACT_APP_FMRREPORT_URL}?format=pdf&quarter=${quarterState}&year=${toDateHandlerState}`
      //   : `${process.env.REACT_APP_REPORT_BASE_URL}/download?report_category=${reportCategoryState}&report_sub_category=${newSubCategory}&start_date=${fromDateHandlerState}&end_date=${toDateHandlerState}`;
      // document.body.appendChild(link);
      // link?.click();
      // document.body.removeChild(link);
    } catch (error) {
      navigate(-1);
      showToast(
        error?.response?.data?.message || "Error in fetching list",
        "error",
        true
      );
    }
  };

  const updatedReports = (allReports, currentEmpId) => {
    if (excludeEmployeesList.includes(currentEmpId)) {
        return allReports;
    } else {
        let updatedReports = structuredClone(allReports);
        updatedReports["Standard Report"] = updatedReports["Standard Report"].filter(report => {
            return report.sub_category_name !== "RLMU Repudiation OD" && report.sub_category_name !== "RLMU Repudiation TP";
        });
        return updatedReports;
    }
  };

  useEffect(() => {
    const decodedToken = secureData(loginToken, "string_decrypt");
    const infoFromToken = jwtDecode(decodedToken);

    reportsDropdown().then((data) => {
      const result = updatedReports(data?.data, infoFromToken?.employeeId);
      setReportsList(result);
    });
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <Box sx={boxStyle}>
        <Box sx={{ display: "block", width: "100%" }}>
          <Box className={style.box}>
            <Typography sx={downloadReportTypography}>
              Download Reports
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box sx={boxStyleTab}>
        <Box sx={WholeBoxStyle}>
          <Grid container spacing={1}>
            <Grid
              item
              xs={6}
              sm={6}
              md={2.8}
              sx={{ paddingTop: "3px !important" }}
            >
              <CustomSelect
                afterSx={{ height: "4.4rem", border: "1px solid #E8E8E8" }}
                placeholder="Report category"
                handleChange={handleChangeReportCategory}
                options={Object.keys(reportsList)}
                customSelectValue={reportCategoryState}
              />
            </Grid>
            <Grid
              item
              xs={6}
              sm={6}
              md={4}
              style={{
                marginRight: "2.2rem",
              }}
              sx={{ paddingTop: "3px !important" }}
            >
              <div style={{ width: "100%" }}>
                <CustomSelect
                  afterSx={{ height: "4.4rem", border: "1px solid #E8E8E8" }}
                  placeholder="Sub-category"
                  open={openSubSelect}
                  openSelect={true}
                  onClose={() => {
                    setOpenSubSelect(false);
                  }}
                  onOpen={() => {
                    setOpenSubSelect(true);
                  }}
                  handleChange={handleChangeSubReportCategory}
                  options={
                    reportsList[reportCategoryState]?.map(
                      (item) => item?.sub_category_name
                    ) || []
                  }
                  customSelectValue={subReportCategoryState}
                />
              </div>
            </Grid>
            <Grid
              item
              xs={6}
              sm={6}
              md={1.2}
              sx={{ paddingTop: "3px !important" }}
            >
              {isFMR ? (
                <CustomSelect
                  afterSx={{ height: "4.4rem", border: "1px solid #E8E8E8" }}
                  placeholder="Quarter"
                  handleChange={handleQuarterChange}
                  options={["Q1", "Q2", "Q3", "Q4"]}
                  customSelectValue={quarterState}
                />
              ) : (
                !isDailyRegCases && (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label={"From"}
                      disableHighlightToday={true}
                      disableFuture={true}
                      sx={fromDatePickerStyle}
                      value={
                        fromDateHandlerState
                          ? dayjs(fromDateHandlerState)
                          : null
                      }
                      onChange={fromDateHandlerFun}
                      slots={{
                        openPickerIcon: CalendarMonthOutlinedIcon,
                      }}
                      slotProps={{
                        popper: {
                          sx: popperStyles,
                        },
                      }}
                    />
                  </LocalizationProvider>
                )
              )}
            </Grid>
            {!isDailyRegCases && (
              <Grid
                item
                xs={6}
                sm={6}
                md={1.2}
                style={{
                  marginRight: "9rem",
                }}
                sx={{ paddingTop: "3px !important" }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    label={isFMR ? "Year" : "To"}
                    views={isFMR ? ["year"] : null}
                    disableHighlightToday={true}
                    disableFuture={true}
                    sx={toDatePickerStyle}
                    value={
                      toDateHandlerState
                        ? isFMR
                          ? dayjs().year(toDateHandlerState)
                          : dayjs(toDateHandlerState)
                        : null
                    }
                    onChange={toDateHandlerFun}
                    slots={{
                      openPickerIcon: CalendarMonthOutlinedIcon,
                    }}
                    slotProps={{
                      popper: {
                        sx: popperStyles,
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>
            )}
            <Grid
              item
              xs={6}
              sm={6}
              md={1}
              sx={{ paddingTop: "3px !important" }}
            >
              <CommonButton
                label="Download"
                onClick={handleReportsDownload}
                filledButton
                fontSize="1.4rem"
                sx={downloadButtonStyle}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default MisReports;
